// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#contact-details[data-v-6c6254e2]{grid-gap:10px;display:grid}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Customers/Contacts/Show.vue"],"names":[],"mappings":"AACA,kCAEI,aAAA,CADA,YACA","sourcesContent":["\n#contact-details {\n    display: grid;\n    grid-gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
